<template>
  <v-dialog v-model="dialog" max-width="290px">
    <template v-slot:activator="{}">
      <v-text-field
          v-model="input"
          :label="label"
          :error-messages="errorMessages"
          :disabled="disabled"
          :dense="dense"
          :placeholder="placeholder"
          :clearable="clearable"
          :prepend-icon="prependIcon ? 'event' : null"
          :append-icon="appendIcon ? 'event' : null"
          :hint="hint"
          :background-color="backgroundColor"
          :hide-details="hideDetails"
          :persistent-hint="persistentHint"
          :error="error"
          :outlined="outlined"
          @change="onInputChange"
          @click:clear="onClearClicked"

          v-on:click:prepend="dialog = true"
          v-on:click:append="dialog = true">
          <template v-slot:message="{ message }">
            <span v-html="message"></span>
          </template>
      </v-text-field>
    </template>

    <v-card>
      <v-card-text class="pa-0">
        <v-date-picker
            v-model="date"
            no-title
            scrollable
            locale="ru"
            first-day-of-week="1"
            @change="onDatePickerChange"
            :min="min ? min.format('YYYY-MM-DD') : null"
            :max="max ? max.format('YYYY-MM-DD') : null"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Moment from "moment";

export default {
  name: "DateInput",
  props: {
    value: {
      type: Object,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    errorMessages: {
      type: Array,
      default: () => {
        return [];
      },
    },
    min: {
      type: Object,
      default: () => {
        return null
      }
    },
    max: {
      type: Object,
      default: () => {
        return null
      }
    },

    disabled: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },

    prependIcon: {
      type: Boolean,
      default: true,
    },
    appendIcon: {
      type: Boolean,
      default: false,
    },

    backgroundColor: {
      type: String,
      default: null
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    hint: {
      type: String,
      default: "Нажмите на календарь или введите вручную"
    },
    persistentHint: {
      type: Boolean,
      default: false
    },
    min: {
      type: Object,
      default: () => {
        return null
      }
    },
    max: {
      type: Object,
      default: () => {
        return null
      }
    },
  },

  data() {
    return {
      displayFormat: "DD.MM.YYYY",
      selectorFormat: "YYYY-MM-DD",

      dialog: false,

      input: "",
      menu: false,
      date: null,

      previousValue: undefined,
    };
  },

  methods: {
    onClearClicked() {
      this.input = "";
      this.date = null;

      this.emitInput();
    },
    onInputChange() {
      this.input = typeof this.input === "string" ? (this.input = `${this.input}`.trim()) : "";
      this.date = null;

      if (this.input) {
        const strMoment = Moment(this.input, this.displayFormat);
        if (strMoment.isValid()) {
          this.date = strMoment.format(this.selectorFormat);
          this.input = strMoment.format(this.displayFormat);
        }
      }

      this.emitInput();
    },
    onDatePickerChange() {
      this.input = Moment(this.date, this.selectorFormat).format(
          this.displayFormat
      );
      this.emitInput();
      this.dialog = false
    },

    emitInput() {
      const strMoment = Moment(this.input, this.displayFormat);
      let value = strMoment.isValid() ? strMoment : null;

      if (value !== this.previousValue) {
        this.previousValue = value;
        this.$emit("input", value);
        this.$emit("change", value);
      }
    },

    valueChanged() {
      if (this.value) {
        this.input = this.value.format(this.displayFormat);
        this.date = this.value.format(this.selectorFormat);
      } else {
        this.input = "";
        this.date = null;
      }
    },
  },

  created() {
    this.valueChanged();
  },
  watch: {
    value() {
      this.valueChanged();
    },
  },
};
</script>